import React, { useState, useEffect } from "react";
import { apiService } from "../../services/apiService";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import { toast } from "react-toastify";

const InvoicePage = () => {
  const [loading, setLoading] = useState(true);
  const [requestingInvoice, setRequestingInvoice] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const response = await apiService.get(API_ENDPOINTS.ACCOUNTS.INVOICE_GET);
      // Store the complete invoice data from the response
      if (response) {
        setInvoiceData(response);
        setInvoiceStatus(response.status);
      }
    } catch (err) {
      console.error("Error fetching invoices:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleRequestInvoice = async () => {
    try {
      setRequestingInvoice(true);
      const response = await apiService.post(API_ENDPOINTS.ACCOUNTS.INVOICE_REQUEST);
      toast.success("Invoice request submitted successfully!");

      // Refresh invoice data to get updated status
      await fetchInvoices();
    } catch (err) {
      console.error("Error requesting invoice:", err);
      toast.error("Failed to submit invoice request. Please try again.");
    } finally {
      setRequestingInvoice(false);
    }
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 mb-0">Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Invoice Management</h4>
            </div>
            <div className="card-body text-center py-5">
              <div className="mb-4">
                <i className="feather-file-text text-primary" style={{ fontSize: "4rem" }}></i>
                <h4 className="mt-3 mb-2">Invoice Management</h4>
                <p className="text-muted mb-4">
                  {invoiceStatus === "in_progress"
                    ? "Your invoice request is currently being processed. Please wait for completion."
                    : invoiceStatus === "not_started"
                      ? "Invoice request has not been started yet. Please wait for processing to begin."
                      : "Click the button below to request a new invoice."
                  }
                </p>
              </div>

              {/* Show button only if status is null (initial) or not in_progress/not_started */}
              {(!invoiceStatus || (invoiceStatus !== "in_progress" && invoiceStatus !== "not_started")) && (
                <div className="d-flex justify-content-center">
                  <button
                    className="btn btn-success btn-lg"
                    onClick={handleRequestInvoice}
                    disabled={requestingInvoice}
                  >
                    {requestingInvoice ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Requesting Invoice...
                      </>
                    ) : (
                      <>
                        <i className="feather-plus-circle me-2"></i>
                        Request Invoice
                      </>
                    )}
                  </button>
                </div>
              )}


              {invoiceData && (invoiceStatus === "in_progress" || invoiceStatus === "not_started") && (
                <div className="mt-4">
                  <div className="row justify-content-center">
                    <div className="col-md-9">
                      <div className="card border-0" style={{
                        backgroundColor: '#ffdcdcff', // Light theme color
                        color: '#212529' // Light theme text color
                      }}>
                        <div className="card-body">
                          <h6 className="card-title mb-3">Invoice Details</h6>
                          <div className="row justify-content-center">
                            <div className="col-3">
                              <small className="d-block">Mobile Number</small>
                              <span className="fw-bold">{invoiceData.mobile_number}</span>
                            </div>
                            <div className="col-3">
                              <small className="d-block">Status</small>
                                <span className={`badge ${invoiceData.status === 'not_started' ? 'bg-secondary' : invoiceData.status === 'in_progress' ? 'bg-warning' : 'bg-success'}`}>
                                  {invoiceData.status === 'not_started' ? 'Not Started' : 
                                   invoiceData.status === 'in_progress' ? 'In Progress' : 
                                   invoiceData.status}
                                </span>
                            </div>
                            <div className="col-3">
                              <small className="d-block">Notes</small>
                              <span className="fw-bold">{invoiceData.notes}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePage;